import { render, staticRenderFns } from "./xiaofang.vue?vue&type=template&id=0977801a&scoped=true&"
import script from "./xiaofang.vue?vue&type=script&lang=js&"
export * from "./xiaofang.vue?vue&type=script&lang=js&"
import style0 from "./xiaofang.vue?vue&type=style&index=0&id=0977801a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0977801a",
  null
  
)

export default component.exports